export const appendSlash = (url) => url && !url.endsWith('/') ? `${url}/` : url;
//# sourceMappingURL=appendSlash.js.map